import { useGetETSTicketPartsQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import styles from './styles.module.scss';
import TicketPartsList from './TicketPartsList/TicketPartsList';

interface TicketPartsProps {
  ticketId: string;
}

const TicketParts = (props: TicketPartsProps) => {
  const { ticketId } = props;
  const { data: parts, isFetching: isLoading } = useGetETSTicketPartsQuery({
    path: {
      ticket_id: ticketId,
    },
  });

  return (
    <div className={styles.partsContainer}>
      <TicketPartsList title="Ersatzteile" parts={parts ? parts.parts : []} isLoading={isLoading} />
      {parts && parts.alternatives.length > 0 && (
        <TicketPartsList title="Alternative Artikel" parts={parts ? parts.alternatives : []} />
      )}
      {parts && parts.defectives.length > 0 && (
        // @ts-expect-error
        <TicketPartsList title="Defekte Artikel" parts={parts.defectives.map((p) => ({ ...p, amount: undefined }))} />
      )}
    </div>
  );
};

export default TicketParts;
